import { render, staticRenderFns } from "./ContestGroupEvaluation.vue?vue&type=template&id=a94ed2a4&scoped=true&"
import script from "./ContestGroupEvaluation.vue?vue&type=script&lang=js&"
export * from "./ContestGroupEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./ContestGroupEvaluation.vue?vue&type=style&index=0&id=a94ed2a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94ed2a4",
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend-internal/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BButton, BRow, BCollapse} from 'bootstrap-vue'
    installComponents(component, {BCol, BButton, BRow, BCollapse})
    


    import installDirectives from "!/Users/jurajpetras/dev/pmat/web/frontend-internal/node_modules/bootstrap-vue-loader/lib/runtime/installDirectives.js"
    import {VBToggle} from 'bootstrap-vue'
    installDirectives(component, {'b-toggle': VBToggle})
    

export default component.exports